import React from 'react';
import { X } from 'lucide-react';
import { VISIBILITY_OPTIONS } from './vaultConstants';

export function EditDocumentModal({
  selectedDocument,
  setSelectedDocument,
  documentTypes,
  onSubmit,
  onClose,
}) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="edit-modal">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900">Edit Document</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full"><X className="w-5 h-5 text-gray-500" /></button>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Document Title</label>
            <input type="text" value={selectedDocument.title} onChange={(e) => setSelectedDocument(prev => ({ ...prev, title: e.target.value }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500" required data-testid="edit-title-input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Document Type</label>
            <select value={selectedDocument.document_type} onChange={(e) => setSelectedDocument(prev => ({ ...prev, document_type: e.target.value }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500" data-testid="edit-type-select">
              {documentTypes.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Who can view this document?</label>
            <div className="space-y-2">
              {VISIBILITY_OPTIONS.map(opt => {
                const Icon = opt.icon;
                return (
                  <label key={opt.value} className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${selectedDocument.visibility === opt.value ? 'border-teal-500 bg-teal-50' : 'border-gray-200 hover:border-gray-300'}`}>
                    <input type="radio" name="edit-visibility" value={opt.value} checked={selectedDocument.visibility === opt.value} onChange={(e) => setSelectedDocument(prev => ({ ...prev, visibility: e.target.value }))} className="sr-only" />
                    <Icon className={`w-5 h-5 ${selectedDocument.visibility === opt.value ? 'text-teal-600' : 'text-gray-400'}`} />
                    <div><p className="font-medium text-gray-900">{opt.label}</p><p className="text-xs text-gray-500">{opt.description}</p></div>
                  </label>
                );
              })}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea value={selectedDocument.description || ''} onChange={(e) => setSelectedDocument(prev => ({ ...prev, description: e.target.value }))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500" rows={2} data-testid="edit-description-input" />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">Cancel</button>
            <button type="submit" className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors" data-testid="edit-submit-btn">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}
